import React from 'react';
import { Link } from 'react-router-dom';
import './CatalogoButton.css';

// 1. Adicione 'onClick' nas propriedades que o componente recebe
export default function CatalogoButton({ currentPath, buttonPath, onClick }) { 
  const isActive = currentPath === buttonPath;

  return (
    <Link
      to={buttonPath}
      className={`CatalogoButton ${isActive ? 'active' : ''}`}
      onClick={onClick} // 2. Repasse o onClick para o Link
    >
      PRODUTOS
    </Link>
  );
}
